import CryptoJS from 'crypto-js' // 引入crypto
import i18n from '@/i18n/index.js'
export function numberExchange(value) {
  if (isNaN(parseInt(value))) return value
  if (!value) return 0
  // 检查是否为负数
  const isNegative = value.toString().startsWith('-')
  // 获取整数部分
  const intPart = Math.trunc(value)
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
  // 预定义小数部分
  let floatPart = ''
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split('.')
  if (valueArray.length === 2) {
    // 有小数部分
    floatPart = valueArray[1].toString() // 取得小数部分
    return (isNegative && intPartFormat.indexOf('-') < 0 ? '-' : '') + intPartFormat + '.' + floatPart
  }
  return (isNegative && intPartFormat.indexOf('-') < 0 ? '-' : '') + intPartFormat + floatPart
}

export function sizeTostr(size) {
  var data = (size / (1024 * 1024)).toFixed(2)
  var sizestr = data + ''
  var len = sizestr.indexOf('.')
  var dec = sizestr.substr(len + 1, 2)
  if (dec === '00') {
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
  }
  return sizestr
}

export function getSize(num) {
  return (num || 0) * (window.innerWidth / 1440)
  // return (num || 0) * (window.innerHeight / 900)
}
export function getvw(num) {
  return ((num || 0) / 1440) * 100 + 'vw'
  // return ((num || 0) / 900) * 100 + 'vh'
}

export function downloadExcel(res, name) {
  const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
  // for IE
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    const fileName = name + '.xls'
    window.navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    // for Non-IE (chrome, firefox etc.)
    const fileName = name + '.xls'
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}

export function encrypt(word) {
  const key = '123456789LISTEKT' // 16位加密密钥，16位则位128bit
  const iv = 'TRUEKEY123456789' // 16位偏移量，可与密钥相同
  var ciphertextBytes = CryptoJS.enc.Hex.parse(word)
  var keyBytes = CryptoJS.enc.Utf8.parse(key)
  var ivBytes = CryptoJS.enc.Utf8.parse(iv)
  // 使用 AES/CBC/Pkcs7 解密方式进行解密
  var decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertextBytes }, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  // 返回解密后的明文
  return decrypted.toString(CryptoJS.enc.Utf8)
}

/**
 * 数组对象数据分组
 * params: {
 *  list: Array[Object]，原数据列表
 *  filed：String，数据列表中，需要分组的key
 * }
 * @return list: Array[Object]，中分组后的数据
 * @return list.key: Array[Object]，中分组后的数据key
 * @return list.data: Array[Object]，中分组后的数据list
 */
export function getArrListToGroup(list, filed) {
  const temObj = {}
  for (let i = 0; i < list.length; i++) {
    const item = list[i]
    if (!temObj[item[filed]]) {
      temObj[item[filed]] = [item]
    } else {
      temObj[item[filed]].push(item)
    }
  }
  const resArr = []
  Object.keys(temObj).forEach((key) => {
    resArr.push({
      key: key,
      data: temObj[key]
    })
  })
  return resArr
}

export function validatePhone(rule, value, callback) {
  const reg = /^1[3456789]\d{9}$/
  if (!value) return callback(new Error(i18n.t('retrievePassword.name11')))
  if (!reg.test(value)) {
    callback(new Error(i18n.t('retrievePassword.name16')))
  } else {
    callback()
  }
}

// 邮箱验证
export function validateEmail(rule, value, callback) {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  if (!value) return callback(new Error(i18n.t('retrievePassword.name17')))
  if (!reg.test(value)) {
    callback(new Error(i18n.t('retrievePassword.name18')))
  } else {
    callback()
  }
}

// 密码验证
export function validatePass(rule, value, callback) {
  // var regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
  const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&.]{6,}$/
  if (value === '') {
    callback(new Error(i18n.t('retrievePassword.name6')))
  } else if (value.length < 6) {
    callback(new Error(i18n.t('retrievePassword.name19')))
  } else if (!regex.test(value)) {
    callback(new Error(i18n.t('retrievePassword.name20')))
  } else {
    callback()
  }
}
